<template>
    <div>
        <Table :fields="fields" :items="signals" :filtered="filtered" :goDetail="goDetail"  :transactions="transactions" :actionEvent="actionEvent"
         :limit="limit" :type="type" :setLimit="setLimit" :changeType="changeType" :rightMenus="actions" :rmClick="actionEvent"/>
        <SignalProcess :signal="lastSignal" :state="detail" :modalEvent="openModal"  />
        <Modals :open="modalOpen" :modalEvent="openModalDefine" :modalProps="modalProps" :modalName="modalName" :getSignal="getSignal"  />

    </div>
</template>

<script>
    import Table from "./components/Table"
    import SignalProcess from './components/SignalProcess';
    import jwt_decode from "jwt-decode";
    import Modals from './modals';
    import i18n from '@/plugins/i18n'

    let fields = [
        { key: 'id', label: 'ID' },
        { key: 'priorty', label: i18n.t('signal.list.priority') },
        { key: 'signal_date', label: i18n.t('signal.list.signalDate') },
        { key: 'account_no', label: i18n.t('signal.list.accountNo') },
        { key: 'account_info', label: i18n.t('signal.list.accountInfo') },
        { key: 'signal_detail', label: i18n.t('signal.list.signalDetail') },
        { key: 'alarm_code', label: i18n.t('signal.list.alarmCode') },
        { key: 'signal_settings', label: i18n.t('signal.list.signalSettings') },
        { key: 'zone_desc', label: i18n.t('signal.list.zoneDesc') },
        { key: 'user', label: i18n.t('signal.list.user') },
        { key: 'AlrSignalNotes', label: i18n.t('signal.list.signalNotes') },
    ];
    let filtered = ['signal_date', "account_no", 'account_info', 'alarm_code', 'signal_settings', 'zone_desc', 'AlrSignalNotes'];
    let actions = [
        {key:'postpone', text: i18n.t('signal.list.postpone'), postpone: true},
        {key:'note', text: i18n.t('signal.list.noteHistory')},
        {key:'account', text: i18n.t('signal.list.goAccountCard')},
        {key:'undoProcess', text: i18n.t('signal.list.undoProcess'), process: false}
    ]
    let transactions = [
        {key:'postponeAll', text: i18n.t('signal.list.postponeAll')},
        {key:'processAll', text: i18n.t('signal.list.processAll')},
        {key:'postponeList', text: i18n.t('signal.list.postponeList')}
    ]

    export default {
        name: "TrafficList",
        data: () =>{
            return {
                lastSignal: {},
                detail: false,
                connected: false,
                items: [], fields, filtered, actions, transactions, 
                limit: 10,
                type: true,
                modalOpen: false,
                modalProps: {},
                modalName:''
            }
        },
        components:{
             Table, SignalProcess, Modals
        },
       
        created: function(){
            this.join()
            this.$store.dispatch("signal_group_list", {limit: 100, offset:0});
            this.$connect()

        },
        mounted() {
            this.unwatch = this.$store.watch(
                state => state.Socket.socket.isConnected,
                (newValue, oldValue) => {
                    if (newValue === true && oldValue === false ) {
                       this.join()
                    }
                }
            );
            },
        beforeDestroy() {
            this.unwatch();  // Don't forget to unwatch when the component is destroyed
        },
        watch:{
            limit(){
                this.signals = []
                this.getSignal()
            },
            type(){
                this.$store.state.Socket.signals = []
                this.getSignal()
            }
        },
        computed:{
            signals(){
                return this.$store.state.Socket.signals
            }
        },
        methods: {
            setLimit: function(limit){
                this.limit = limit
                this.$store.state.Socket.limit = limit
            },
            changeType: function(val){
                this.type = val
                this.$store.state.Socket.alarm = val
            },
            openModal: function(val, type, data, note, result){
                this.detail = val
                if(type == 'busy' && this.type){
                    this.busy(data, true)
                }else  if(type == 'process'){
                    this.process(data, note, result)
                }else if(type == 'cancel'){
                    this.busy(data, false)
                }
            },
            openModalDefine: function(status, name, val){
                this.modalOpen = status,
                this.modalProps = val,
                this.modalName = name
            },
            join(){
                // socket e katıl
                let params =  {
                    "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                    "event" : "join",
                    "limit": this.limit,
                    "is_alarm": this.type
                }
                this.$socket.send(JSON.stringify(params))
            },
            getSignal(){
                // socket e katıl
                let params =  {
                    "user_id": jwt_decode(localStorage.getItem('access_token')).user_id,
                    "event" : "getsignals",
                    "limit": this.limit,
                    "is_alarm": this.type
                }
                this.$socket.send(JSON.stringify(params))
            },
            busy(data, busy) {
                // Sinyali Meşgula Al
                let params = {
                    signal_id: data.id,
                    user_id: jwt_decode(localStorage.getItem('access_token')).user_id,
                    is_busy: busy,
                    event : "busySignal",
                }
                this.$socket.send(JSON.stringify(params))
            },
            process(data, note, result) {
                let params =  {
                    user_id: jwt_decode(localStorage.getItem('access_token')).user_id,
                    event : "processSignal",
                    signal_id: data.id,
                    note: note,
                    result_id: result
                }
                this.$socket.send(JSON.stringify(params))
                this.getSignal()
            },
            goDetail: async function(item){
                this.$store.dispatch('signalDetail', {acnt_id: item.account_info.id})
                this.$store.dispatch('getAccountHours',{accountId: item.account_info.id})
                this.$store.dispatch('getAccountUsers', {accountId: item.account_info.id, type: 1}) 
                this.$store.dispatch("listQuickNotes");
                this.$store.dispatch("listEvaluationResults");

                this.lastSignal = item
                this.openModal(true, 'busy', item)
            },
             actionEvent: async function(key,item){
               switch(key){
                   case 'account':
                        this.$router.push( { path: '/Accounts/'+item.account_info.customer.id+'/'+item.account_info.id+'/edit' }) 
                        break;
                    case 'postpone':
                        this.openModalDefine(true, 'Postpone', item)
                        break;
                    case 'postponeAll':
                        this.openModalDefine(true, 'Postpone', {allPostpone: true})
                        break;
                    case 'processAll':
                        this.openModalDefine(true, 'Process', {})
                        break;
                    case 'undoProcess':
                        this.openModalDefine(true, 'SetState', { state: 0, signal: item})
                        break;
                    case 'note':
                        this.openModalDefine(true, 'NoteHistory', item)
                        break;
                    case 'postponeList':
                        this.openModalDefine(true, 'PostponeList', {})
                        break;
               }
            },
        }
    }
</script>

<style scoped>
 .modal-body{
    padding: 0 !important;

  }
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/TrafficList.vue